import * as types from 'modules/releases/actionTypes';

/**
 * @param {string|null} releaseId
 * @param {boolean} [previewMode=false]
 * @param {boolean} [fetchDetailedRelease=false]
 * @param {Object} [meta={}]
 * @returns {OpenReleaseModalAction}
 */
export const openReleaseModal = (releaseId = null, previewMode = false, fetchDetailedRelease = true, meta = {}) => ({
  type: types.OPEN_RELEASE_MODAL,
  payload: { releaseId, previewMode, fetchDetailedRelease },
  meta,
});

/**
 * @param {Object} [meta={}]
 * @returns {CloseReleaseModalAction}
 */
export const closeReleaseModal = (meta = {}) => ({
  type: types.CLOSE_RELEASE_MODAL,
  meta,
});

/**
 * @param {string|null} releaseId
 * @param {Object} [meta={}]
 * @returns {UpdateReleaseModalAction}
 */
export const updateReleaseModal = (releaseId = null, meta = {}) => ({
  type: types.UPDATE_RELEASE_MODAL,
  payload: { releaseId, fetchDetailedRelease: true },
  meta,
});
